module.exports = __webpack_public_path__ + "img/home.8b9bb581.svg";